<script setup lang="ts">
const modelValue = defineModel<string>();
</script>

<template>
  <input v-model="modelValue" class="phxsg-input" />
</template>

<style src="./input.css" />
